import {
  IRequirementResponse,
  RequirementExpirationStatus
} from "@wingspanhq/payments/dist/interfaces";

export const selectorIsRequirementNotExpiring = (
  requirement: IRequirementResponse
) => {
  return requirement.expirationStatus !== RequirementExpirationStatus.Expiring;
};
